import { type ButtonHTMLAttributes, type ReactNode } from 'react';
import { Icon, type IconName } from './Icon.js';

interface ChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  on?: boolean;
  icon?: IconName;
  size?: 'sm' | 'md';
  children: ReactNode;
}

export function Chip({ on, icon, size = 'md', children, onClick, style, className, ...rest }: ChipProps) {
  return (
    <button
      type="button"
      className={`chip ${className ?? ''}`}
      data-on={on ? '1' : '0'}
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        fontFamily: 'inherit',
        padding: size === 'sm' ? '4px 10px' : '6px 12px',
        fontSize: size === 'sm' ? 11.5 : 12.5,
        ...style,
      }}
      {...rest}
    >
      {icon && <Icon name={icon} size={12} />}
      {children}
    </button>
  );
}
